import { ReactNode } from "react";
import { Layout } from "@/components/layout";

type Props = {
  kicker: string;
  title: ReactNode;
  effectiveDate: string;
  intro?: ReactNode;
  children: ReactNode;
};

export function LegalLayout({ kicker, title, effectiveDate, intro, children }: Props) {
  return (
    <Layout>
      {/* Hero */}
      <section className="border-b border-border bg-foreground text-background relative overflow-hidden">
        <div className="absolute inset-0 bg-grid-sm opacity-[0.06] pointer-events-none" aria-hidden="true" />
        <div className="container mx-auto px-4 py-20 md:py-28 relative z-10">
          <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-secondary mb-6">
            {kicker}
          </div>
          <h1 className="font-display text-4xl md:text-6xl lg:text-7xl font-bold leading-[1.02] tracking-tight text-balance max-w-4xl">
            {title}
          </h1>
          <div className="mt-8 font-mono text-[11px] uppercase tracking-widest text-background/60">
            Effective {effectiveDate}
          </div>
        </div>
      </section>

      <div className="container mx-auto px-4 py-16 md:py-20 max-w-3xl">
        {intro && (
          <div className="prose prose-neutral dark:prose-invert max-w-none text-lg leading-relaxed mb-12">
            {intro}
          </div>
        )}

        <article className="prose prose-neutral dark:prose-invert max-w-none prose-headings:font-display prose-headings:tracking-tight prose-h2:text-2xl md:prose-h2:text-3xl prose-h2:mt-12 prose-h2:mb-4 prose-h3:text-lg prose-h3:mt-8 prose-h3:mb-3 prose-p:leading-relaxed prose-li:leading-relaxed prose-a:text-primary hover:prose-a:underline">
          {children}
        </article>

        <div className="mt-16 pt-8 border-t border-border text-sm text-muted-foreground">
          <p>
            Questions? Email{" "}
            <a href="mailto:info@mainloopacademy.com" className="text-primary hover:underline">
              info@mainloopacademy.com
            </a>
            .
          </p>
        </div>
      </div>
    </Layout>
  );
}
